/**
 * Catálogo único de formas de pago / condición de venta en comprobantes de venta.
 * Si agregás o quitás una opción, modificá solo este archivo.
 */
export const FORMAS_DE_PAGO_VENTA = [
  'CONTADO',
  'CTA.CTE.',
  'EFECTIVO',
  'DEVOLUCION',
  'CONTRAREEMBOLSO',
] as const;

export type FormaDePagoVenta = (typeof FORMAS_DE_PAGO_VENTA)[number];
